import { toast } from "sonner";
import artieImage from "@/assets/images/sm-hat.png";

export const showTaskCompleteToast = () => {
  toast.custom((t) => (
    <div
      className="flex items-center gap-4 bg-[#1F1F1F] text-white p-4 rounded-xl shadow-2xl border border-gray-800 max-w-md w-full cursor-pointer hover:bg-[#2A2A2A] transition-colors"
      onClick={() => toast.dismiss(t)}
    >
      <div className="relative flex-shrink-0">
        <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center overflow-hidden border-2 border-white/10">
          <img src={artieImage} alt="Artie" className="w-full h-full object-cover" />
        </div>
        {/* Party hat decoration could be added here if we had the asset, for now just the Artie image as requested */}
      </div>
      <div className="flex-1">
        <p className="text-sm font-medium leading-relaxed">
          Nice work! Your Artie score just went up thanks to a completed task. Momentum looks good.
        </p>
      </div>
      {/* Add a subtle close indicator */}
      <div className="text-white/60 text-xs ml-2">
        ✕
      </div>
    </div>
  ), {
    position: 'top-center',
    duration: 3000, // Reduced from 5000ms to 3000ms (3 seconds)
    dismissible: true, // Make it dismissible
  });
};